<template>
	<div>
		<div class="x-stat">
			<a-row>
				<a-col :span="3">
					<a-statistic title="数量" :value="totalRow" />
				</a-col>
			</a-row>
		</div>

		<a-card :bordered="false">
			<div class="x-filter">
				<a-form layout="inline">
					<a-row :gutter="24">
						<a-col :span="4">
							<a-form-item label="用户">
								<a-input v-model="queryParams.user" placeholder="id/昵称" />
							</a-form-item>
						</a-col>
						<a-col :span="4">
							<a-form-item label="性别">
								<a-select v-model="queryParams.sex" placeholder="请选择" default-value="">
									<a-select-option value="MALE">男</a-select-option>
									<a-select-option value="FEMALE">女</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>

						<template v-if="advanced">
							<a-col :md="8">
								<a-form-item label="注册时间">
									<a-range-picker @change="onCreateTime" v-model="createTime" style="width:100%" />
								</a-form-item>
							</a-col>

							<a-col :md="8">
								<a-form-item label="活跃时间">
									<a-range-picker @change="onActiveTime" v-model="activeTime" style="width:100%" />
								</a-form-item>
							</a-col>
						</template>
						<a-col :span="!advanced && 4 || 24">
							<span class="x-filter-submit-box"
								:style="advanced && {float:'right', overflow:'hidden'} || {}">
								<a-button type="primary" @click="fetchTableData">查询</a-button>
								<a-button style="margin-left:8px" @click="rest()">重置</a-button>
								<a @click="toggleAdvanced" style="margin-left: 8px">
									{{ advanced ? '收起' : '展开' }}
									<a-icon :type="advanced ? 'up' : 'down'" />
								</a>
							</span>
						</a-col>
					</a-row>
				</a-form>
			</div>

			<a-table :rowKey="record => record.id" :columns="tableColumns" :loading="tableLoading"
				:dataSource="tableData" :pagination="false">
				<template slot="conversation" slot-scope="record">
					<div class="complex">
						<span v-if="record.type=='SECRET'">私聊</span>
						<span v-else-if="record.type=='CLUSTER'">群聊</span>
						<span v-else>系统通知</span>
					</div>
				</template>

				<template slot="user" slot-scope="record">
					<div class="user">
						<div class="user-left">
							<img class="cover-img" :src="record.userAvatarUrl" width="48px" height="48px" />
						</div>
						<div class="user-right">
							<p class="first">
								<span class="nickname">{{ record.userNickname }}</span>
							</p>
							<p class="row">
								<span class="user-right-detail" v-if="record.sex=='MALE'">男</span>
								<span class="user-right-detail" v-else>女</span>
								<span class="user-right-detail">{{ record.userAge }}岁</span>
								<span class="user-right-detail">{{ record.userProvince }}{{ record.toUserCity }}</span>
							</p>
						</div>
					</div>
				</template>
				<template slot="toUser" slot-scope="record">
					<div class="user">
						<div class="user-left">
							<img class="cover-img" :src="record.toUserAvatarUrl" width="48px" height="48px" />
						</div>
						<div class="user-right">
							<p class="first">
								<span class="nickname">{{ record.toUserNickname }}</span>
							</p>
							<p class="row">
								<span class="user-right-detail" v-if="record.sex=='MALE'">男</span>
								<span class="user-right-detail" v-else>女</span>
								<span class="user-right-detail">{{ record.toUserAge }}岁</span>
								<span
									class="user-right-detail">{{ record.toUserProvince }}{{ record.toUserCity }}</span>
								<span class="user-right-detail">单身</span>
							</p>
						</div>
					</div>
				</template>

				<template slot="message" slot-scope="record">
					<div class="complex">
						<span>{{ record.messageNum }}</span>
					</div>
				</template>

				<template slot="voice" slot-scope="record">
					<div class="complex">
						<span>{{ record.voletNum }}/{{ record.voletDuration }}</span>
					</div>
				</template>

				<template slot="video" slot-scope="record">
					<div class="complex">
						<span>{{ record.viletNum }}/{{ record.viletDuration }}</span>
					</div>
				</template>

				<template slot="gift" slot-scope="record">
					<div class="complex">
						<span>{{ record.giftNum }}/{{ record.giftAmount }}</span>
					</div>
				</template>
				<template slot="action" slot-scope="record">
					<a @click="openMessageDetail(record)">查看</a>
				</template>
			</a-table>

			<div class="x-pagination">
				<a-pagination :pageSize="pageSize" v-model="pageIndex" :total="totalRow" @change="pageChange"
					:hideOnSinglePage="true" show-less-items />
			</div>
		</a-card>

		<conversation-message-drawer
			:visible.sync="messageDrawerVisible"
			:conversation-id="messageDrawerConversationId"
			:from-user-info="messageDrawerFromUser"
			:to-user-info="messageDrawerToUser"
			:title="messageDrawerTitle"
		/>
	</div>
</template>

<script>
	import moment from "moment";
	import { conversationList } from "@/api/op/conversation.js";
	import ConversationMessageDrawer from '@/components/ConversationMessageDrawer.vue';

	const tableColumns = [{
			title: '#',
			dataIndex: 'id',
		},
		{
			title: '会话',
			scopedSlots: {
				customRender: 'conversation'
			}
		},
		{
			title: '发起用户',
			scopedSlots: {
				customRender: 'user'
			}
		},
		{
			title: '对方用户',
			scopedSlots: {
				customRender: 'toUser'
			}
		},
		{
			title: '消息',
			scopedSlots: {
				customRender: 'message'
			}
		},
		{
			title: '语音',
			scopedSlots: {
				customRender: 'voice'
			}
		},
		{
			title: '视频',
			scopedSlots: {
				customRender: 'video'
			}
		},
		{
			title: '礼物',
			scopedSlots: {
				customRender: 'gift'
			}
		},
		{
			title: '时间',
			dataIndex: 'created'
		},
		{
			title: '操作',
			scopedSlots: {
				customRender: 'action'
			}
		}
	];

	export default {
		components: {
			ConversationMessageDrawer,
		},
		data() {
			return {
				advanced: false,
				queryParams: {},
				totalRow: 0,
				tableColumns,
				tableData: [],
				tableLoading: false,
				pageSize: 20,
				pageIndex: 1,
				formVisible: false,
				formLoading: false,
				formModel: null,
				createTime: [],
				activeTime: [],
				messageDrawerVisible: false,
				messageDrawerConversationId: 0,
				messageDrawerFromUser: {},
				messageDrawerToUser: {},
				messageDrawerTitle: '',
			}
		},
		created() {
			this.fetchTableData();
		},
		methods: {
			fetchTableData() {
				this.tableLoading = true;
				this.queryParams.pageSize = this.pageSize;
				this.queryParams.page = this.pageIndex;
				conversationList(this.queryParams).then(res => {
					this.totalRow = res.data.totalRow;
					this.tableData = res.data.conversationList;
					this.tableLoading = false;
				});
			},
			toggleAdvanced() {
				this.advanced = !this.advanced;
			},
			onCreateTime(values) {
				this.queryParams.startCreateTime = moment(values[0]).unix();
				this.queryParams.endCreateTime = moment(values[1]).unix();
			},
			onActiveTime(values) {
				this.queryParams.startActiveTime = moment(values[0]).unix();
				this.queryParams.endActiveTime = moment(values[1]).unix();
			},
			pageChange(current) {
				this.pageIndex = current;
				this.fetchTableData();
			},
			rest() {
				this.activeTime = [];
				this.createTime = [];
				this.queryParams = {}
			},
			openMessageDetail(record) {
				// conversation_user 表：用 conversationId 拉取消息，用 user_id / to_user_id 区分双方
				const conversationId = record.conversationId != null ? record.conversationId : record.id;
				this.messageDrawerConversationId = conversationId;
				this.messageDrawerFromUser = {
					id: record.userId,
					avatar: record.userAvatarUrl,
				};
				this.messageDrawerToUser = {
					id: record.toUserId,
					avatar: record.toUserAvatarUrl,
				};
				this.messageDrawerTitle = (record.userNickname || '') + '与' + (record.toUserNickname || '') + '对话';
				this.messageDrawerVisible = true;
			},
		}
	}
</script>

<style lang="less" scoped>
	.user {
		display: flex;
		flex-direction: row;

		.user-left {
			display: flex;
			flex-direction: column;
			margin-right: 5px;
			text-align: center;

			span {
				font-size: 12px;
			}
		}

		.user-right {
			p.first {
				display: flex;
				flex-direction: row;
				margin: 0;

				.nickname {
					color: #686868;
					font-weight: bold;
				}
			}

			p.row {
				font-size: 12px;
				color: #acacac;
				margin: 0;
			}

			.user-right-detail {
				margin-right: 5px;
			}
		}
	}


	.clearfix {
		width: 100%;
	}

	.complex {
		display: flex;
		flex-direction: column;

		p {
			margin: 0;
		}
	}

	.assist {
		font-size: 12px;
		color: #acacac;
	}
</style>